import React, { useState, useRef, useEffect } from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import GoogleMapKey from "../../../../pages/Utils/googleMapKey";
import { FaMotorcycle, FaUserClock, FaUserCheck } from "react-icons/fa";
import ReactDOMServer from "react-dom/server";

const containerStyle = {
  width: "100%",
  height: "450px",
};

const COLORS = [
  "#007BFF",
  "#FF5733",
  "#28A745",
  "#FFC107",
  "#6F42C1",
  "#20C997",
  "#E83E8C",
  "#FD7E14",
  "#17A2B8",
  "#6610F2",
  "#FF6F61",
  "#4CAF50",
  "#9C27B0",
  "#03A9F4",
  "#FF9800",
  "#8BC34A",
  "#795548",
  "#009688",
  "#F44336",
  "#607D8B",
];

const lightenColor = (hex, percent) => {
  const num = parseInt(hex.replace("#", ""), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) + amt;
  const G = ((num >> 8) & 0x00ff) + amt;
  const B = (num & 0x0000ff) + amt;
  return (
    "#" +
    (
      0x1000000 +
      (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
      (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
      (B < 255 ? (B < 1 ? 0 : B) : 255)
    )
      .toString(16)
      .slice(1)
  );
};

const AgentsMapComponents = ({ deliveryData }) => {
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [colorMap, setColorMap] = useState({});
  const mapRef = useRef(null);
  const [mapCenter] = useState({ lat: 26.0667, lng: 50.5577 });

  console.log(deliveryData,"deliveryData");
  

  useEffect(() => {
    if (!deliveryData?.length) return;

    setColorMap((prevMap) => {
      const newMap = { ...prevMap };
      let colorIndex = Object.keys(prevMap).length;

      deliveryData.forEach((agent) => {
        if (!newMap[agent.agentId]) {
          newMap[agent.agentId] = COLORS[colorIndex % COLORS.length];
          colorIndex++;
        }
      });

      return newMap;
    });
  }, [deliveryData]);

  const getAgentIcon = (color) => {
    if (!mapLoaded || !window.google?.maps?.Size) return null;
    const svgString = ReactDOMServer.renderToString(
      <FaMotorcycle color={color} size={36} />
    );
    const svgBase64 = `data:image/svg+xml;base64,${btoa(svgString)}`;
    return {
      url: svgBase64,
      scaledSize: new window.google.maps.Size(55, 55),
      anchor: new window.google.maps.Point(27, 27),
    };
  };

  const getCustomerIcon = (status, color) => {
    if (!window.google?.maps?.Size) return null;
    const icon =
      status === "Delivered" ? (
        <FaUserCheck color={color} size={20} />
      ) : (
        <FaUserClock color={color} size={20} />
      );
    const svgString = ReactDOMServer.renderToString(icon);
    const svgBase64 = `data:image/svg+xml;base64,${btoa(svgString)}`;
    return {
      url: svgBase64,
      scaledSize: new window.google.maps.Size(32, 32),
      anchor: new window.google.maps.Point(16, 16),
    };
  };

  const onLoad = (map) => {
    mapRef.current = map;
    setMapLoaded(true);
  };

  return (
    <div>
      <LoadScript googleMapsApiKey={GoogleMapKey}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={mapCenter}
          zoom={10}
          onLoad={onLoad}
        >
          {deliveryData?.map((agent) => {
            const agentColor = colorMap[agent.agentId] || "#999";
            const customerColor = lightenColor(agentColor, 10);

            return (
              <React.Fragment key={agent.agentId}>
                <Marker
                  position={agent.currentLocation}
                  icon={getAgentIcon(agentColor)}
                  onClick={() => setSelectedMarker(agent)}
                  label={{
                    text: agent.agentName,
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "#000",
                  }}
                />

                {agent.customers?.map((customer) => (
                  <Marker
                     key={`${agent.agentId}-${customer?.id || customer?.customerId || Math.random()}`}
                    position={{ lat: customer.lat, lng: customer.lng }}
                    icon={getCustomerIcon(customer.status, customerColor)}
                    onClick={() =>
                      setSelectedMarker({
                        ...customer,
                        agentName: agent.agentName,
                      })
                    }
                    label={{
                      text: customer.name,
                      fontSize: "10px",
                      color: "#333",
                    }}
                  />
                ))}
              </React.Fragment>
            );
          })}

          {selectedMarker && (
            <InfoWindow
              position={
                selectedMarker.currentLocation
                  ? selectedMarker.currentLocation
                  : { lat: selectedMarker.lat, lng: selectedMarker.lng }
              }
              onCloseClick={() => setSelectedMarker(null)}
            >
              <div style={{ minWidth: "220px", fontFamily: "Arial" }}>
                {selectedMarker.agentPhone ? (
                  <>
                    <h3>🚴 {selectedMarker.agentName}</h3>
                    <p>
                      <strong>Phone:</strong> {selectedMarker.agentPhone}
                    </p>
                  </>
                ) : (
                  <>
                    <h3>🏠 {selectedMarker.name}</h3>
                    <p>
                      <strong>Agent:</strong> {selectedMarker.agentName}
                    </p>
                    <p>
                      <strong>Status:</strong> {selectedMarker.status}
                    </p>
                  </>
                )}
              </div>
            </InfoWindow>
          )}
        </GoogleMap>
      </LoadScript>
    </div>
  );
};

export default AgentsMapComponents;
